import { PageController } from '@client/components/_core/layout/PageController';
import { Tabs } from '@client/components/_core/navigation/Tabs';
import { createFileRoute } from '@tanstack/react-router';
import { BrushCleaning } from 'lucide-react';

export const Route = createFileRoute('/admin-console/tools/sanitise-text-pii')({
    staticData: {
        permissions: ['admin_system:full'],
        ui: {
            icon: BrushCleaning,
            title: 'Sanitise text PII',
            menuDescription: 'Strip personal information from arbitrary text using a configurable PII strategy',
        },
        breadcrumb: {
            title: 'Sanitise text PII',
        },
    },
    component: RouteComponent,
});

function RouteComponent() {
    return (
        <PageController route={Route}>
            <SanitizeTextPii />
        </PageController>
    );
}

function SanitizeTextPii() {
    return (
        <Tabs
            items={[
                {
                    label: 'Tool',
                    to: '/admin-console/tools/sanitise-text-pii/tool',
                },
                {
                    label: 'Complete compare',
                    to: '/admin-console/tools/sanitise-text-pii/compare',
                },
            ]}
        />
    );
}
